namespace AgerLMS.LMS {
    export interface NeighbourhoodsRow {
        Id?: number;
        DistrictId?: number;
        Name?: string;
        PostCode?: string;
        DistrictCityId?: number;
        DistrictCode?: number;
        DistrictName?: string;
    }

    export namespace NeighbourhoodsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'LMS.Neighbourhoods';
        export const lookupKey = 'LMS.Neighbourhoods';

        export function getLookup(): Q.Lookup<NeighbourhoodsRow> {
            return Q.getLookup<NeighbourhoodsRow>('LMS.Neighbourhoods');
        }
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            DistrictId = "DistrictId",
            Name = "Name",
            PostCode = "PostCode",
            DistrictCityId = "DistrictCityId",
            DistrictCode = "DistrictCode",
            DistrictName = "DistrictName"
        }
    }
}
